import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { ConnectedEntity } from "src/types/apps";
import { isValidToken } from "src/utils/jwt";

import { apiClient } from "../../config/apiClient";
import { API } from "../../config/apiConfig";
import { EntityAuthField } from "./NetTypes";

async function getLinkEntitiesRequest(authToken: string) {
	return await apiClient
		.get(API.QUERY.LINK.ENTITIES, {
			headers: { Authorization: `Bearer ${authToken}` }
		})
		.then((res) => res.data);
}

export function useGetLinkEntitiesRequest(authToken: string) {
	return useQuery<ConnectedEntity[], AxiosError>({
		queryKey: ["link", "entities", authToken],
		queryFn: () => getLinkEntitiesRequest(authToken),
		enabled: !!authToken,
		initialData: []
	});
}

async function getEntityLoginParamsRequest(entityId: string, id: string) {
	return await apiClient
		.get(API.QUERY.LINK.LOGIN_PARAMS(entityId), { params: { id } })
		.then((res) => res.data);
}

async function getEntityLoginParamsRequest2(entityId: string, authToken: string, lang: string) {
	return await apiClient
		.get(API.QUERY.LINK.LOGIN_PARAMS(entityId), {
			headers: { "Accept-Language": lang, Authorization: `Bearer ${authToken}` }
		})
		.then((res) => res.data);
}

export function useGetEntityLoginParams(entityId: string, id: string) {
	return useQuery<string[], AxiosError>({
		queryKey: ["link", "entities", entityId, "params"],
		queryFn: () => getEntityLoginParamsRequest(entityId, id),
		initialData: []
	});
}

export function useGetEntityLoginParams2(entityId: string, authToken: string, lang: string) {
	return useQuery<EntityAuthField[], AxiosError>({
		queryKey: ["link", "entities", entityId, "params2"],
		queryFn: () => getEntityLoginParamsRequest2(entityId, authToken, lang),
		initialData: [],
		enabled: !!authToken && isValidToken(authToken)
	});
}
